import { Injectable } from '@angular/core';
import * as _ from 'lodash';

enum Element {
  Nodes = 'Nodes',
  VoipPeers = 'Voip Peers',
  Connections = 'Connections',
  PeerConnections = 'Peer Connections'
}

@Injectable({
  providedIn: 'root'
})
export class NetworkFilterService {

  constructor() { }

  public static haveNonSearchableFields(object: any, stringsArray: any): boolean {
    for (const property in object) {
      if (object.hasOwnProperty(property)) {
        if (stringsArray.indexOf(property) === -1 && object[property].value !== null) {
          return true;
        }
      }
    }
    return false;
  }

  public static formatSearchObject(searchObject) {
    let result;
    if (typeof searchObject === 'string') {
      if (searchObject === '') {
        result = undefined;
      } else {
        result = {
          freeText: searchObject
        };
      }
    } else {
      result = searchObject;
      this.formatElementParameter(result, searchObject);
    }
    return result;
  }

  private static formatElementParameter(result, searchObject) {
    const equalsOperator = '=';
    if (searchObject.elements) {
      result.nodes = {value : this.isElementExists(searchObject.elements.value, Element.Nodes), operator: equalsOperator};
      result.voipPeers = {value : this.isElementExists(searchObject.elements.value, Element.VoipPeers), operator: equalsOperator};
      result.connections = {value : this.isElementExists(searchObject.elements.value, Element.Connections), operator: equalsOperator};
      result.pCons = {value : this.isElementExists(searchObject.elements.value, Element.PeerConnections), operator: equalsOperator};

      delete result.elements;
    } else if (this.toSelectAllElements(result)) {
      result.nodes = {value : 'yes', operator: equalsOperator};
      result.voipPeers = {value : 'yes', operator: equalsOperator};
      result.connections = {value : 'yes', operator: equalsOperator};
      result.pCons = {value : 'yes', operator: equalsOperator};
    }
  }

  private static isElementExists(searchObject: any, element: string) {
    return (searchObject.indexOf(element) !== -1) ? 'yes' : null;
  }

  private static toSelectAllElements(result): boolean {
    return _.isNil(result.nodes) && _.isNil(result.voipPeers) &&
        _.isNil(result.connections) && _.isNil(result.pCons);
  }
}
